<template>
  <div class="home-page login-content" style="padding-top: 0;">
    <Header></Header>
    <div class="login login-send">
      <div class="home-prize ac">
        <img style="width: 70%" src="../../static/images/login_tip.png"/>
      </div>
      <div class="landing-page">
        <div class="input-div">
          <div class="span mt20 fs33 fw7" style="font-weight: 800;margin-bottom: 15px;color: white">
            {{ $t('loginTips') }}
          </div>
          <div class="input-item mt20">
            <div class="input-item2">
              <span class="app-en num_09"></span>
              <input readonly style="height: 100px;color: black;font-size: 55px" class="input" v-model="mobile" type="number" placeholder="">
            </div>
          </div>
        </div>

        <div class="ac " style="margin-top: 40px">
          <div class="drown-list login-list" style="width: 100%">
            <div class="disflex" style="background:none;box-shadow: none;justify-content: space-evenly;">
              <div class="land-btn day_week" v-if="showDaily" :class="{'active': type === 'daily'}" @click="handleSubscribe('daily')">
                <div class="day">
                  {{ $t('Daily') }}
                </div>
              </div>
              <div class="land-btn month_week" v-if="showWeekly" :class="{'active': type === 'weekly'}" @click="handleSubscribe('weekly')">
                <div class="week">
                  {{ $t('Weekly') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ac otp-b disflex mt100">
          <div style="color: white" class="icon icon2 fw7" @click="getToNav('termsAndCondition')">{{ $t('TC') }} <span
            class="app-en">>></span></div>
          <div style="color: white" class="icon icon2 fw7" @click="getToNav('faq')">{{ $t('FAQ') }} <span
            class="app-en">>></span></div>
        </div>
      </div>
    </div>
    <Dialog ref="resubDialog" type="alert" title="Reminder" width="84" :modalFoot="false" modalClass="sub-modal-shell">
      <div class="resub-dialog invited-c ac" slot="mdBox">
        <div class="invited-l">
          <div class="dialog-title-block">
            <span class="dialog-title">{{ $t('re_sub_tip') }}</span>
            <p class="dialog-desc">{{ $t('choose_tip') }}</p>
          </div>
          <div class="level-img-wrapper action-card" @click="goCG()">
            <img src="../../static/images/login_sub.png" class="level-img">
            <span class="level-text font-family">{{ $t('subscribe') }}</span>
          </div>
          <div class="level-img-wrapper action-card" @click="goLogin()">
            <img src="../../static/images/login_login.png" class="level-img">
            <span class="level-text font-family">{{ $t('Login') }}</span>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog ref="subDialog" type="alert" title="Reminder" width="86" :modalFoot="false" modalClass="sub-modal-shell">
      <div class="otp-dialog invited-c ac" slot="mdBox">
        <div class="invited-l otp-dialog-inner">
          <div class="dialog-title-block otp-title-block">
            <span class="dialog-title otp-title">{{ $t('enter_otp') }}</span>
          </div>
          <div class="otp-input-panel">
            <div class="otp-input-row">
              <input class="otp-field input" v-model="otp" ref="getFocus2" maxlength="4" type="number" placeholder="Enter OTP">
              <button class="otp-resend-btn" :class="{disable:codeText != $t('getCode')}" type="button" :disabled="codeText != $t('getCode')" @click="subSendOtp">{{ codeText }}</button>
            </div>
          </div>
          <button class="otp-submit-btn" type="button" @click="verifySendOtp()">
            {{ $t('subscribe') }}
          </button>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Header from '../components/HeaderTwo'
import Dialog from '../components/dialog'
import CryptoJS from '../../static/js/crypto-js.min.js'

export default {
  components: {
    Header,
    Dialog
  },
  data() {
    return {
      list: [],
      mobile: '',
      type: '',
      showDaily: true,
      showWeekly: true,
      otp: '',
      codeText: '',
      isReturn: false,
      pollTimer: null
    }
  },
  created() {
    this.codeText = this.$t('getCode')
    if (localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    if (this.$route.query.mobile) {
      this.mobile = this.dealPhone_2(this.$route.query.mobile);
    }
    if (this.$route.query.msidn) {
      let ss = this.aesEcbDecrypt(this.$route.query.msidn);
      this.mobile = this.dealPhone_2(ss);
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.type === 'daily') {
      this.showDaily = true
      this.showWeekly = false
    } else if (this.type === 'weekly') {
      this.showWeekly = true
      this.showDaily = false
    }
  },
  mounted() {
    //渠道是atomber 且 有号码的
    const channelId = this.$route.query.channelId
    // 渠道是 atomber 且有手机号，自动发送 OTP
    if (channelId === 'atomber' && this.mobile) {
      this.type = 'daily';
      this.goCG()
    }
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  },
  methods: {
    handleSubscribe(type) {
      this.type = type
      this.userStatus()
    },
    userStatus() {
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      let mobile = '09' + that.mobile
      mobile = that.dealPhone(mobile)
      const userAgent = navigator.userAgent;
      const deviceId = this.getDeviceId();
      let encrypt_mobile = that.aesEcbEncrypt(mobile);
      let data = {
        msidn: encrypt_mobile,
        user_agent: userAgent,
        device_id: deviceId
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/user_status', data, r => {
        that.$parent.loadModal(false);
        that.$parent.returnCode(r, function () {
          if (r.code == 0) {
            that.$utils.alertText(r.msg, 80);
          } else {
            if (r.data.status == 1 || r.data.status == -2) {
              if (r.data.change_device) {
                that.goOtpLogin();
                return;
              } else {
                that.goLogin();
                return;
              }
            }
            if (r.data.status == 3 && r.data.valid == 'Y') {
              that.$refs.resubDialog.showMaskFun();
            } else {
              that.goCG();
            }
          }
        })
      })
    },
    getToNav(url) {
      this.$router.push({path: '/' + url});
    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, '');
      if (phone.startsWith('97') && phone.length === 10) {
        phone = phone.substring(1);
      }
      return phone;
    },
    dealPhone(phone) {
      phone = phone.replace(/\s+/g, '');
      if (phone.startsWith('0909') && phone.length === 13) {
        phone = phone.substring(3);
      }
      if (phone.startsWith('09') && phone.length === 11) {
        phone = phone.substring(1);
      }
      if (phone.startsWith('099') && phone.length === 12) {
        phone = phone.substring(2);
      }
      return phone;
    },
    getDeviceId() {
      let id = localStorage.getItem('device_id');
      if (!id) {
        id = 'dev-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('device_id', id);
      }
      return id;
    },
    goLogin() {
      let that = this;
      that.$parent.loadModal(true);
      if (that.mobile === '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        that.$parent.loadModal(false);
        return
      }
      let mobile = that.dealPhone('09' + this.mobile)
      let encrypt_mobile = that.aesEcbEncrypt(mobile);
      let data = {
        msidn: encrypt_mobile
      }
      that.$api.post('/api/user/login', data, r => {
        that.$parent.loadModal(false);
        if (r.code == 1) {
          localStorage.setItem('token', r.data.userinfo.token)
          localStorage.setItem('mobile', r.data.userinfo.mobile)
          this.$router.push({path: '/'})
        } else {
          that.$utils.alertText(r.msg, 80);
        }
      })
    },
    goCG() {
      this.$refs.resubDialog.closeMask();
      this.$refs.subDialog.showMaskFun();
      this.subSendOtp();
    },
    goOtpLogin() {
      let mobile = this.dealPhone('09' + this.mobile)
      let encrypt_mobile = this.aesEcbEncrypt(mobile);
      this.$router.push({path: '/otp', query: {msidn: encrypt_mobile}});
    },
    subSendOtp() {
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      if (that.isReturn) {
        return;
      }
      that.isReturn = true
      let mobile = '09' + that.mobile
      let params = new URLSearchParams(this.$route.query);
      params.delete('mobile');
      params.delete('subappid');
      let encrypt_mobile = that.aesEcbEncrypt(mobile);
      params.set('msidn', encrypt_mobile);
      params.set('subappid', this.type);
      let url = '/api/user/sub_send_otp?' + params.toString();
      that.$parent.loadModal(true);
      that.$api.post(url, {}, r => {
        that.$parent.loadModal(false);
        that.$utils.alertText(r.msg, 80, 2000);
        if (r.code == 1) {
          this.countDown(61, 1)
        }else{
          that.isReturn = false
        }
      })
    },
    verifySendOtp() {
      let that = this
      let mobile = '09' + that.mobile
      let code = this.otp
      if (!code) {
        that.$utils.alertText(that.$t('enter_otp'), 60)
        return;
      }
      let params = new URLSearchParams(this.$route.query);
      params.delete('mobile');
      params.delete('subappid');
      let encrypt_mobile = that.aesEcbEncrypt(mobile);
      params.set('msidn', encrypt_mobile);
      params.set('subappid', this.type);
      params.set('code', code);
      let url = '/api/user/sub_verify_otp?' + params.toString();
      that.$parent.loadModal(true);
      that.$api.post(url, {}, r => {
        that.$parent.loadModal(false);
        that.$utils.alertText(r.msg, 80, 2000);
        if (r.code == 1) {
          that.$refs.subDialog.closeMask();
          that.check_user_status();
        }
      })
    },
    countDown(miao, type) {
      if (miao === 1) {
        this.codeText = this.$t('getCode');
        return;
      }
      miao--;
      if (type === 1) {
        this.codeText = miao + 's';
        this.isReturn = false
      }
      setTimeout(() => {
        this.countDown(miao, type);
      }, 1000)
    },
    check_user_status() {
      let that = this
      let mobile = '09' + that.mobile
      mobile = that.dealPhone(mobile)
      let encrypt_mobile = that.aesEcbEncrypt(mobile);
      let data = {msidn: encrypt_mobile};
      let elapsed = 0;
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
      this.$parent.loadModal(true);
      this.pollTimer = setInterval(() => {
        elapsed += 2;
        that.$api.post('/api/user/user_status', data, r => {
          if (r.data.status === 1) {
            clearInterval(that.pollTimer);
            that.pollTimer = null;
            that.$parent.loadModal(false);
            that.goLogin();
          }
        });
        if (elapsed >= 60) {
          clearInterval(that.pollTimer);
          that.pollTimer = null;
          that.$parent.loadModal(false);
          this.$router.push({path: '/errors'});
        }
      }, 3000);
    },
    aesEcbDecrypt(ciphertextBase64) {
      try {
        const key = CryptoJS.enc.Utf8.parse('jksdfuiAa4so1ewm');
        const encrypted = CryptoJS.enc.Base64.parse(ciphertextBase64);
        const decrypted = CryptoJS.AES.decrypt(
          {ciphertext: encrypted},
          key,
          {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.NoPadding
          }
        );
        return decrypted.toString(CryptoJS.enc.Utf8).replace(/\0+$/, '');
      } catch (e) {
        console.error('AES decrypt failed:', e);
        return '';
      }
    },
    aesEcbEncrypt(plaintext) {
      var key = CryptoJS.enc.Utf8.parse('jksdfuiAa4so1ewm');
      var data = CryptoJS.enc.Utf8.parse(plaintext);
      var blockSize = 16;
      var padLen = (blockSize - (data.sigBytes % blockSize)) % blockSize;
      var words = data.words.slice(0);
      var wordArray = CryptoJS.lib.WordArray.create(words, data.sigBytes + padLen);
      var encrypted = CryptoJS.AES.encrypt(wordArray, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.NoPadding
      });
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    }
  }
}
</script>
<style scoped>
.drop-down-content {
  z-index: 9;
  background: none;
}

.mt100 {
  margin-top: 100px;
}

.otp-b {
  justify-content: space-evenly;
}

.login-list .drown-li {
  min-width: 320px;
}

.login-list .drown-li + .drown-li {
  margin-left: 30px;
}

.login-list .drown-li + .drown-li .disflex {
  background: #0065f3;
}

.level-img-wrapper {
  position: relative;
  width: 90%;
  margin: 0 auto;
}

.level-img {
  width: 100%;
  display: block;
}

.level-text {
  position: absolute;
  top: 60%;
  left: 35%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 40px;
  text-align: center;
  font-weight: bold;
}

.dialog-title-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  margin-top: 10px;
}

.dialog-badge {
  min-width: 140px;
  padding: 10px 22px;
  border-radius: 999px;
  background: linear-gradient(135deg, #8a2eff, #5c35ff);
  box-shadow: 0 10px 24px rgba(92, 53, 255, 0.28);
  color: #fff;
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
}

.dialog-title {
  color: #243068;
  font-size: 38px;
  line-height: 1.35;
  font-weight: 700;
}

.dialog-desc {
  margin: 0;
  color: #7a84a8;
  font-size: 24px;
  line-height: 1.5;
}

.resub-dialog,
.otp-dialog {
  width: 100%;
}

.resub-dialog .invited-l,
.otp-dialog-inner {
  width: 100%;
}

.action-card {
  margin-top: 26px;
  transition: transform 0.2s ease, filter 0.2s ease;
}

.action-card:active {
  transform: scale(0.98);
  filter: brightness(0.98);
}

.otp-title-block {
  gap: 10px;
}

.otp-title {
  font-size: 42px;
}

.otp-input-panel {
  margin-top: 18px;
  padding: 18px;
  border-radius: 30px;
  background: linear-gradient(180deg, #ffffff, #f8f9ff);
  border: 2px solid rgba(129, 91, 255, 0.16);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.65);
}

.otp-input-row {
  display: flex;
  align-items: center;
  gap: 14px;
}

.otp-field {
  flex: 1;
  height: 88px;
  padding: 0 28px;
  border: 2px solid #e0e6ff;
  border-radius: 22px;
  background: #fff;
  color: #25306a;
  font-size: 34px;
  font-weight: 700;
  box-sizing: border-box;
}

.otp-field::placeholder {
  color: #b0b8d8;
  font-size: 28px;
  font-weight: 500;
}

.otp-resend-btn {
  min-width: 150px;
  height: 88px;
  padding: 0 22px;
  border: 0;
  border-radius: 22px;
  background: linear-gradient(135deg, #ffb54d, #ff8a47);
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  box-shadow: 0 12px 24px rgba(255, 144, 63, 0.26);
}

.otp-resend-btn.disable {
  background: linear-gradient(135deg, #ffd7af, #ffc895);
  color: rgba(255, 255, 255, 0.92);
  box-shadow: none;
}

.otp-submit-btn {
  width: 100%;
  height: 94px;
  margin-top: 30px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(135deg, #8d2eff, #5b2bff);
  box-shadow: 0 16px 32px rgba(109, 61, 255, 0.3);
  color: #fff;
  font-size: 34px;
  font-weight: 800;
  letter-spacing: 1px;
}

:deep(.sub-modal-shell .modal-bg) {
  background: rgba(8, 17, 58, 0.66);
  backdrop-filter: blur(6px);
}

:deep(.sub-modal-shell .modal-content) {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(244, 247, 255, 0.98));
  border-radius: 36px;
  padding: 28px 24px 30px;
  border: 2px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 26px 60px rgba(20, 33, 84, 0.34);
  overflow: visible;
}

:deep(.sub-modal-shell .modal-warp) {
  padding: 10px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/page/sub.vue